/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Property_Style_HelpInputs */



/**
* | output |
* | --- |
* | "Caption style and forced subtitle flag" |
*
* @param {Event_Group_Sync_Property_Style_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_property_style_help = /** @type {((inputs?: Event_Group_Sync_Property_Style_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Property_Style_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Caption style and forced subtitle flag")
	if (locale === "de") return /** @type {LocalizedString} */ ("Caption style and forced subtitle flag")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caption style and forced subtitle flag")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Caption style and forced subtitle flag")
	if (locale === "es") return /** @type {LocalizedString} */ ("Caption style and forced subtitle flag")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Caption style and forced subtitle flag")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Caption style and forced subtitle flag")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Caption style and forced subtitle flag")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Caption style and forced subtitle flag")
	return /** @type {LocalizedString} */ ("Caption style and forced subtitle flag")
});